import * as apiActions from '@configuratorware/configurator-frontendgui/App/Reducers/Actions';
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import {
  RECEIVE_OPTIONS,
  SELECT_OPTIONCLASSIFICATION,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import {
  switchOptions,
  setOptionclassificationChecked,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { getActiveStepComponents } from './Selectors';

interface OptionclassificationOptionData {
  identifier: string;
  data: any;
}

export const actionTypes = {
  SET_STEP_STATE: 'SET_STEP_STATE',
  SET_INITIAL_ACTIVE_STEP: 'SET_INITIAL_ACTIVE_STEP',
  SET_OPTION_CLASSIFICATION_OPTIONS: 'SET_OPTION_CLASSIFICATION_OPTIONS',
  RECEIVE_LANGUAGES: 'RECEIVE_LANGUAGES',
};

export interface LanguageItem {
  iso: string;
  dateFormat?: string;
  dateTimeFormat?: string | null;
  decimalpoint?: string;
  priceDecimals?: number;
  numberDecimals?: number | null;
  thousandsSeparator?: string;
  currencySymbolPosition?: string;
}

export const receiveLanguages = (data: unknown) => ({
  type: actionTypes.RECEIVE_LANGUAGES,
  data: Array.isArray(data) ? data : [],
});

export const fetchLanguages = () => (dispatch: (action: unknown) => void) => {
  return dispatch(apiActions.fetchData('languages', receiveLanguages));
};

export const setStepState = (identifier, state) => ({
  type: actionTypes.SET_STEP_STATE,
  identifier,
  state,
});

export const setOptionclassificationOption = (payload: OptionclassificationOptionData) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_OPTION_CLASSIFICATION_OPTIONS,
    payload,
  });
};

export const receiveOptions = (json, extraData) => async (dispatch, getState) => {
  const { optionclassification } = extraData;
  const { configuration } = getState().configurator;

  if (getConf('checkOptionclassificationOnSelect')) {
    dispatch(setOptionclassificationChecked(optionclassification));
  }

  await dispatch({
    type: SELECT_OPTIONCLASSIFICATION,
    optionclassification: configuration.optionclassifications.find(
      (o) => o.identifier === optionclassification
    ),
  });
  return dispatch({
    type: RECEIVE_OPTIONS,
    data: json,
    receivedAt: Date.now(),
  });
};

export const setInitialActiveStep = () => ({
  type: actionTypes.SET_INITIAL_ACTIVE_STEP,
});

export const selectOption =
  (option, optionclassification, refreshStepOptionsLists = false) =>
  async (dispatch, getState) => {
    const state = getState();
    const { configuration } = state.configurator;
    dispatch(setVisible('startHere', false));

    const switchOptionData = {
      [optionclassification.identifier]: {
        ...option,
        amount: isNaN(parseInt(option.amount)) ? 0 : option.amount,
        check_results: null,
      },
    };

    await dispatch(switchOptions(configuration, switchOptionData, false, false, true));
    // reloading all the optionsList in the active step
    if (refreshStepOptionsLists) {
      loadStepOptionClassificationOptions();
    }
  };

export const loadStepOptionClassificationOptions =
  (activeStepOptionClassifications = getActiveStepComponents()) =>
  async (dispatch, getState) => {
    const state = getState();
    const { configuration } = state.configurator;
    // fetching options of active step OptionClassifications
    activeStepOptionClassifications.forEach(async (oc) => {
      const result = await dispatch(fetchOptions(configuration.item.identifier, oc, configuration));
      // asyncRequest() returns undefined when a newer request for the same URL superseded this one
      if (!result) return;
      dispatch(setOptionclassificationOption({ identifier: oc, data: result.data }));
    });
  };

export const fetchOptions = (itemidentifier, optionclassification, configuration) => async (dispatch) => {
  return await dispatch(
    apiActions.postDataAsync(
      'options/list/' + itemidentifier + '/' + optionclassification,
      { configuration },
      receiveOptions,
      {}, // config
      { optionclassification } // extraData
    )
  );
};
